export default __webpack_public_path__ + "static/media/fa-solid-900.5ff6f359.svg";